exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#bottom-ad[data-v-0b437f3e]{background:#f8f8f8}#bottom-ad .bottom-banner[data-v-0b437f3e]{text-align:center;padding:24px 0}@media (max-width:767px){#bottom-ad .bottom-banner[data-v-0b437f3e]{padding:16px 0}}", ""]);

